import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { endOfWeek, format, getISOWeek, startOfWeek } from 'date-fns';
import { fetchSensor } from '../../../modules/sensors/actions';
import SideNav from '../../../Layout/SideNav';
import { Layout, Row, Col, DatePicker, Flex } from 'antd';
import HeaderBar from '../../../Layout/HeaderBar';
import { AdminAndMichael } from '../../../components/AdminOnly';
import { useAqSensor } from './useAqSensors';
import { AppState } from '../../../store';
import LineChart from './Chart';
import Realtime from './Realtime';
import ReportCheckbox from './Report';
import { Link } from 'react-router-dom';
import { LinkOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/da_DK';
import dayjs from 'dayjs';
import SensorInternalOverview from '../components/SensorInternalOverview';

const { Content } = Layout;

function Page({ children, backLink, backText, orgId, sensorId }: any) {
  return (
    <>
      <SideNav />
      <Layout>
        <HeaderBar backLink={backLink} backText={backText} />
        <Content style={{ margin: '50px 24px 0' }}>
          <SensorInternalOverview orgId={orgId} sensorId={sensorId} sensorType="ESP_AQ" />
          <Row gutter={16}>
            <Col md={24} xs={24} style={{ minHeight: '600px' }}>
              {children}
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
}

function AQSensorContainer(props: any) {
  console.log({ AQSensorContainer: 'AQSensorContainer' });

  const { orgId, sensorId } = props.match.params;
  const [date, setdate] = useState<string | null>(null);
  useEffect(() => {
    props.fetchSensor({ orgId, sensorId });
    return () => {};
  }, []);

  const onChangeDate = (date: any) => {
    console.log({ date, type: typeof date });
    if (!date) return;
    const dateObj = date.toDate();

    const dateToUse = format(startOfWeek(dateObj, { weekStartsOn: 1 }), 'yyyy-MM-dd');

    setdate(`${dateToUse}T00:00:00.000Z`);
  };
  const getDateDisplay = () => {
    if (!date) return null;
    const week = getISOWeek(new Date(date));
    return `Viser data fra ${format(new Date(date), 'd. MMM yyyy')} til ${format(
      endOfWeek(new Date(date), { weekStartsOn: 1 }),
      'd. MMM yyyy'
    )} - Uge ${week}`;
  };

  return (
    <Page
      backLink={`/orgs/${orgId}/sensors`}
      backText={props.title}
      orgId={orgId}
      sensorId={sensorId}
    >
      {/* <AdminOnly> */}
      <h2>{getDateDisplay()}</h2>
      <div
        style={{
          marginTop: -28,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 8,
        }}
      >
        <div>
          {/* @ts-ignore */}
          <DatePicker
            locale={locale}
            value={date ? dayjs(date) : undefined}
            onChange={onChangeDate}
            picker="week"
            allowClear={false}
          />
        </div>
        <Flex align="center" gap="small">
          <AdminAndMichael>
            <ReportCheckbox />
          </AdminAndMichael>
          <Flex vertical align="end" gap="middle">
            <Link to={`/sensor-legend`} target="_blank">
              <LinkOutlined /> Sensor information
            </Link>
            {props.deviceId && <Realtime deviceId={props.deviceId} />}
          </Flex>
        </Flex>
      </div>
      {/* @ts-ignore */}
      {/* <DatePicker
                key="day"
                locale={locale}
                onChange={onChangeDate}
                allowClear={false}
            /> */}
      {/* </AdminOnly> */}
      <GraphContainer deviceId={props.deviceId} date={date} thresholds={props.thresholds} />
      {/* <AirQualitySensor
                title={props.title}
                data={data}
                units={sensor?.units}
                thresholds={props.thresholds}
            /> */}
    </Page>
  );
}
function GraphContainer({
  deviceId,
  date,
  thresholds,
}: {
  deviceId: string;
  date: string | null;
  thresholds: any;
}) {
  const { logsAndStats, isLoading } = useAqSensor(deviceId, date);
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!logsAndStats?.pm_2_5 || logsAndStats?.pm_2_5?.length < 1) {
    return <div>Ingen data for perioden</div>;
  }
  const units = Object.keys(logsAndStats).filter((key) => key !== 'co2Avg');
  return (
    <LineChart
      pm_2_5={logsAndStats?.pm_2_5}
      pm_10={logsAndStats?.pm_10}
      co2={logsAndStats?.co2}
      co2Avg={logsAndStats?.co2Avg}
      decibel={logsAndStats?.decibel}
      lux={logsAndStats?.lux}
      temperature={logsAndStats?.temperature}
      humidity={logsAndStats?.humidity}
      units={units}
      thresholds={thresholds}
    />
  );
}

function mapStateToProps(state: AppState) {
  return {
    title: state.sensors.currentSensor.title,
    deviceId: state.sensors.currentSensor.deviceId,
    thresholds: state.sensors.currentSensor.thresholds,
    loading: state.sensors.loading,
  };
}

const mapActionsToProps = {
  fetchSensor,
  // fetchSensorLogs,
  // fetchSensorMeasures,
  // setDate,
};

const withConnect = connect(mapStateToProps, mapActionsToProps);

export default compose(withConnect, withRouter)(AQSensorContainer);
